import * as React from "react";
import { DateSelectComponent } from "./DateSelectComponent";

import { EnquiryContext } from "./context/EnquiryState";

const days = [
	{
		id: 1,
		label: "Mon"
	},
	{
		id: 2,
		label: "Tue"
	},
	{
		id: 3,
		label: "Wed"
	},
	{
		id: 4,
		label: "Thu"
	},
	{
		id: 5,
		label: "Fri"
	},
	{
		id: 6,
		label: "Sat"
	},
	{
		id: 0,
		label: "Sun"
	},
];

const activeDayButton = 'button bg-skin-cacti rounded-full text-center text-base text-black font-semibold border-skin-cacti border-2';
const inactiveDayButton = 'button rounded-full text-center text-base border-skin-cacti border-2 text-black font-semibold';

// Min and Max date constants
var d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var endNextYear = new Date(year + 1, 11, 31);
var today = new Date(year, month, day);
var tenYearsAgo = new Date(year - 10, 0, 1);

export const ChildDetailsComponent = () => {
	
	const {
		state,
		dispatch,
		AddChild,
		SetActiveChildIndex,
		RemoveChild,
		SelectChildDay,
		TrackAnalyticsEvent
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		dispatch({type: "SET_FORM_COMPONENT", payload: "childDetails"})

		if (state.model.skipChildDetails) {
			dispatch({ type: 'SET_STEP', payload: state.currentStep + 1 })
		}

		TrackAnalyticsEvent("child-details")
	}, [])

	let childNameInputs = <React.Fragment>
		{state.form.children.map((child, index) => {
			return <div className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
				<input
					onBlur={() => HandleInputChange(event, 'childsName')}
					defaultValue={child.childsName}
					type="text"
					name="childsName"
					className="enquiry-input"
					placeholder="Enter name"
					aria-invalid="true" />
			</div>
		})}
	</React.Fragment>

	let birthdayPickers = <React.Fragment>
		{state.form.children.map((child, index) => {
			return <div id={`child-bday-${index}`} className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
				<DateSelectComponent OnDateChange={(date) => SetChildsBirthday(date)} value={child.childsBirthday} minDate={tenYearsAgo } maxDate={endNextYear } />
			</div>
		})}
	</React.Fragment>

	let startDatePickers = <React.Fragment>
		{state.form.children.map((child, index) => {
			return <div id={`child-startdate-${index}`} className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
				<DateSelectComponent OnDateChange={(date) => SetChildsStartDate(date)} value={child.startDate} minDate={today} maxDate={endNextYear} />
			</div>
		})}
	</React.Fragment>

	React.useEffect(() => {
		birthdayPickers = <React.Fragment>
			{state.form.children.map((child, index) => {
				return <div id={`child-bday-${index}`} className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
					<DateSelectComponent OnDateChange={(date) => SetChildsBirthday(date)} value={child.childsBirthday} minDate={tenYearsAgo} maxDate={endNextYear}/>
				</div>
			})}
		</React.Fragment>

		startDatePickers = <React.Fragment>
			{state.form.children.map((child, index) => {
				return <div id={`child-startdate-${index}`} className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
					<DateSelectComponent OnDateChange={(date) => SetChildsStartDate(date)} value={child.startDate} minDate={today} maxDate={endNextYear}/>
				</div>
			})}
		</React.Fragment>

		childNameInputs = <React.Fragment>
			{state.form.children.map((child, index) => {
				return <div className={`mb-6 ${index != state.activeChildIndex ? "hidden" : ""}`}>
					<input
						onBlur={() => HandleInputChange(event, 'childsName')}
						defaultValue={child.childsName}
						type="text"
						name="childsName"
						className="enquiry-input"
						placeholder="Enter name"
						aria-invalid="true" />
				</div>
			})}
		</React.Fragment>
	}, [state.totalChildren])

	React.useEffect(() => {
		let childIndex = state.activeChildIndex

		if (state.form.children[childIndex].childsBirthday !== null) {
			document.querySelector(`#child-bday-${childIndex}`).classList.add('filled')
		} else {
			document.querySelector(`#child-bday-${childIndex}`).classList.remove('filled')
		}

		if (state.form.children[childIndex].startDate !== null) {
			document.querySelector(`#child-startdate-${childIndex}`).classList.add('filled')
		} else {
			document.querySelector(`#child-startdate-${childIndex}`).classList.remove('filled')
		}

	}, [state.activeChildIndex])

	const SetChildsBirthday = (date) => {
		let childIndex = state.activeChildIndex
		if (date !== null) {
			document.querySelector(`#child-bday-${childIndex}`).classList.add('filled')
		} else {
			document.querySelector(`#child-bday-${childIndex}`).classList.remove('filled')
		}
		let clonedForm = state.form
		clonedForm.children[childIndex].childsBirthday = date
		dispatch({type: "UPDATE_FORM", payload: clonedForm})
	}

	const SetChildsStartDate = (date) => {
		let childIndex = state.activeChildIndex
		if (date !== null) {
			document.querySelector(`#child-startdate-${childIndex}`).classList.add('filled')
		} else {
			document.querySelector(`#child-startdate-${childIndex}`).classList.remove('filled')
		}
		let clonedForm = state.form
		clonedForm.children[childIndex].startDate = date
		dispatch({ type: "UPDATE_FORM", payload: clonedForm })
	}

	const HandleInputChange = (e, label) => {
		let clonedForm = state.form
		clonedForm.children[state.activeChildIndex][label] = e.target.value
		dispatch({ type: "UPDATE_FORM", payload: clonedForm })
	}

	return (
		<React.Fragment>
			<div className="mb-6">

				<div className="mb-4 font-semibold text-xl">
					What care do you need?
				</div>

				{/*Switch*/}
				<div className="flex flex-row items-centre mb-4 border border-skin-neutral-light rounded-full overflow-hidden bg-skin-site-header">
					{state.form.children.map((child, index) => {
						return <div className={`w-1/${(state.form?.children?.length < 5 ? state.form?.children?.length + 1 : state.form?.children?.length)}`}>
							<button onClick={() => SetActiveChildIndex(index)} className={`px-0 text-base-15 lg:text-base button rounded-none border-l w-full ${state.activeChildIndex == (index) ? "bg-skin-cacti text-black" : "bg-skin-site-header text-black" }`}>
								Child {index + 1}
							</button>
						</div>
					})}

					{state.form?.children?.length < 5 &&
						<div className={`w-1/${(state.form?.children?.length + 1)}`}>
							<button onClick={() => AddChild()} className={`px-0 h-full text-base-15 lg:text-base button rounded-none text-black border-l border-skin-neutral-light w-full bg-skin-site-header flex flex-row items-center justify-center`}>
							<span className="mr-1">Add {state.form.children.length < 3 && <span>Child</span>}</span>
								<img src="/img/icons/circle-add-icon.svg" alt="1" />
							</button>
						</div>
					}
				</div>

				<div className="mb-6">
					<div className="mb-3">
						<label className="text-xs">CHILD'S NAME (OPTIONAL)</label>
					</div>
					{childNameInputs}
				</div>

				<div className="text-xs mb-2">
					CHILDS BIRTHDAY <span className="text-red-400">*</span>
				</div>
				{!!state.childErrors[state.activeChildIndex]?.childsBirthday &&
					<div className="mb-2 text-xs text-red-600">{state.childErrors[state.activeChildIndex].childsBirthday.message}</div>
				}
				{birthdayPickers}

				<div className="text-xs mb-2">
					CARE DAYS <span className="text-red-400">*</span>
				</div>
				{!!state.childErrors[state.activeChildIndex]?.daysRequiredList &&
					<div className="mb-2 text-xs text-red-600">{state.childErrors[state.activeChildIndex].daysRequiredList.message}</div>
				}
				<div className="flex flex-wrap items-center gap-3 mb-6 text-base-15 enquiry-buttons">
					{days.map(day => {
						return <button
							onClick={() => SelectChildDay(day.id)}
							className={state.form.children[state.activeChildIndex].daysRequiredList.includes(day.id) ? activeDayButton : inactiveDayButton}>
							{day.label.charAt(0).toUpperCase() + day.label.slice(1)}
						</button>
					})}
					<button
						onClick={() => SelectChildDay(null)}
						className={state.form.children[state.activeChildIndex].overnightEvening ? activeDayButton : inactiveDayButton}>
						Overnight/evening
					</button>
				</div>

				<div className="text-xs mb-2">
					START DATE <span className="text-red-400">*</span>
				</div>
				{!!state.childErrors[state.activeChildIndex]?.startDate &&
					<div className="mb-2 text-xs text-red-600">{state.childErrors[state.activeChildIndex].startDate.message}</div>
				}
				{startDatePickers}
						
				{state.form?.children?.length > 1 &&
					<div className="text-center">
						<button onClick={ () => RemoveChild()} className="button border border-red-300 text-black">
							Remove
						</button>
					</div>
				}

			</div>
		</React.Fragment>
	);

}